import { ErrorBoundary } from "@sentry/react";
import React, { useEffect, useState } from "react";
import { useUiCustomComponent } from './hooks/useUiCustomComponent';
import { useUiPicker } from './hooks/useUiPicker';
import FormStyle from './components/FormStyle';
import { set } from "lodash";
import useFormEditorState, { AlurkerjaFormContext } from "./state/formeditor.state";
import { UiFromSpec, UiFromSpecProvider } from "./UiFromSpec";
import { Card } from "alurkerja-ui";


interface FormViewerProps {
  spec: any[]
  form?: any
  axiosInstance?: any,
  context?: AlurkerjaFormContext
}


export default function FormViewer({
  spec,
  form,
  axiosInstance,
  context
}: Readonly<FormViewerProps>) {
  const [defaultSpec] = useState<any[]>(spec || []);

  const { setAxiosInstance, setContext} = useFormEditorState();

  const fieldConfig = useUiCustomComponent().fieldConfig;
  const customDndElemets = useUiPicker().customDndElemets;

  useEffect(() => {

    if (context) {
      setContext(context)
    }

  }, []);


  useEffect(() => {
    if (axiosInstance) {
      setAxiosInstance(axiosInstance)
    }
    return () => {

    }
  }, [axiosInstance]);

  if (!axiosInstance) {
    return (
      <Card className="p-4">
        <div className="flex flex-col items-center justify-center">
          <p className="text-lg monSubmitb-4">Loading...</p>
        </div>
      </Card>
    )
  }

  if (defaultSpec.length === 0) {
    return (
      <Card className="p-4">
        <div className="flex flex-col items-center justify-center">
          <p className="text-lg monSubmitb-4">No form available for this user task.</p>
        </div>
      </Card>
    )
  }


  return (
    <>

      <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <UiFromSpecProvider
          propertyEditorState={false}
          editorState={false}

          currentSpecState={defaultSpec}
          overrideDndElements={customDndElemets}
          overrideFieldConfig={fieldConfig}

        >
          <FormStyle>
            <UiFromSpec
              form={form}
              inputSize="small"
              className="!p-0"
              renderViewOnly
              canvasClassname=" flex-1 p-4 h-[calc(100vh-110px)] overflow-auto"
              allowpreview
            />
          </FormStyle>
        </UiFromSpecProvider>
      </ErrorBoundary>

      <div></div>
    </>
  );
}
